
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0a6 6 0 100 12A6 6 0 006 0zm-.88 4.56a.72.72 0 110-1.44.72.72 0 010 1.44zm1.2-2.32a.72.72 0 111.44 0 .72.72 0 01-1.44 0zm1.36 3.52a.96.96 0 110-1.92.96.96 0 010 1.92z"}})])
          )
        }
      }
    